import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import corner4 from "assets/img/illustrations/corner-4.png";
import Background from "components/common/background";
import { faTicketAlt, faComments } from '@fortawesome/free-solid-svg-icons';
import "assets/css/site.css";
import paths from 'routes/paths';
import { useAppContext } from '../../providers/appProvider';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios"; // Import Axios

const Support = () => {
    const { config } = useAppContext();
    const navigate = useNavigate(); // Initialize useNavigate hook
    const prevLocationId = useRef(config.location?.LocationId);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const currentLocationId = config.location?.LocationId;
        if (prevLocationId.current !== currentLocationId) {
            navigate("/dashboard"); // Adjust the path as needed
        }
    }, [config.location?.LocationId]); // Add LocationId to the dependency array

    const getSupportUrl = () => {
        const lang = i18n.language.split("-")[0];
        const baseUrl = process.env.REACT_APP_SUPPORT_URL;
        return lang === "en" ? baseUrl : `${baseUrl}/${lang}`;
    };

    return (
        <div>
            <Row className="g-3 mb-3">
                <Col lg={12} xxl={12}>
                    <Card className="mb-3 h-100">
                        <Background
                            image={corner4}
                            className="bg-card"
                            style={{
                                borderTopRightRadius: "0.375rem",
                                borderBottomRightRadius: "0.375rem",
                            }}
                        />
                        <Card.Body className="position-relative pe-4 pb-2">
                            <Row className="flex-between-center">
                                <Col md>
                                    <h5 className="mb-2 mb-md-0">{t("support")}</h5>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="g-3 mb-3 justify-content-center align-items-stretch">
                <Col lg={12} xxl={12}>
                    <Card className="mb-3 h-100">
                        <Card.Body className="position-relative pe-4 pb-2">
                            <h4 className="mt-3 text-primary text-center">{t("supportSubtitle")}</h4>
                            <Row className="g-3 justify-content-center align-items-stretch mb-3 mt-3">
                                <Col md={4} xxl={4} className="d-flex">
                                    <div className="bg-200 py-x1 text-center rounded-3 position-relative hover-bg-primary flex-fill d-flex flex-column">
                                        <div className="icon-item icon-item-xl text-primary shadow-none mx-auto mt-x1 bg-100">
                                            <FontAwesomeIcon icon="question-circle" />
                                        </div>
                                        <h5 className="mt-3 mb-2">
                                            <a href={paths.faq} className="text-900 hover-primary stretched-link">
                                                {t("frequentlyAskedQuestions")}
                                            </a>
                                        </h5>
                                        <h6 className="w-75 mx-auto text-600 mb-x1">{t("faqText")}</h6>
                                    </div>
                                </Col>
                                <Col md={4} xxl={4} className="d-flex" id="liveChatContainer">

                                    <div className="bg-200 py-x1 text-center rounded-3 position-relative flex-fill d-flex flex-column tile-with-overlay">
                                        <div className="icon-item icon-item-xl text-primary shadow-none mx-auto mt-x1 bg-100">
                                            <FontAwesomeIcon icon={faComments} />
                                        </div>
                                        <h5 className="mt-3 mb-2">
                                            <span className="text-900 hover-primary stretched-link d-inline-block cursor-default">
                                                {t("liveChatTitle")}
                                            </span>
                                        </h5>
                                        <h6 className="w-75 mx-auto text-600 mb-x1">
                                            {t("liveChatText")}
                                        </h6>

                                        {/* Overlay */}
                                        <div className="overlay">
                                            <h4 className="text-white">{t("comingSoon")}</h4>
                                        </div>
                                    </div>
                                </Col>

                                {/* uncomment this and delete above code when adding functionality */}
                                {/* <Col md={4} xxl={4} className="d-flex">
                                    <div className="bg-200 py-x1 text-center rounded-3 position-relative hover-bg-primary flex-fill d-flex flex-column">
                                        <div className="icon-item icon-item-xl text-primary shadow-none mx-auto mt-x1 bg-100">
                                            <FontAwesomeIcon icon={faComments} />
                                        </div>
                                        <h5 className="mt-3 mb-2">
                                        <a href={paths.faq} className="text-900 hover-primary stretched-link">
                                        Live Chat
                                         </a>
                                        </h5>
                                        <h6 className="w-75 mx-auto text-600 mb-x1">Krijg direct ondersteuning van ons team via live chat.</h6>
                                        <div className="overlay">
                                            <h4 className="text-white">Coming Soon...</h4>
                                        </div>
                                    </div>
                                </Col> */}
                                <Col md={4} xxl={4} className="d-flex">
                                    <div className="bg-200 py-x1 text-center rounded-3 position-relative hover-bg-primary flex-fill d-flex flex-column">
                                        <div className="icon-item icon-item-xl text-primary shadow-none mx-auto mt-x1 bg-100">
                                            <FontAwesomeIcon icon={faTicketAlt} />
                                        </div>
                                        <h5 className="mt-3 mb-2">
                                            <a href={getSupportUrl()} target="_blank" className="text-900 hover-primary stretched-link">
                                                {t("submitTicketTitle")}
                                            </a>
                                        </h5>
                                        <h6 className="w-75 mx-auto text-600 mb-x1">{t("submitTicketText")}</h6>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Support;